import { useEffect, useState } from 'react';

type tooltipPossitionProps = {
  arrowSize: number;
  tooltipRef: any;
};

export function useTooltipPosition({
  arrowSize,
  tooltipRef,
}: tooltipPossitionProps) {
  const [tooltipTopPosition, setTooltipTopPosition] = useState(0);

  useEffect(() => {
    if (tooltipRef.current && tooltipRef.current.clientHeight > 0) {
      setTooltipTopPosition(tooltipRef.current.clientHeight + arrowSize);
    }
  }, [tooltipRef, arrowSize]);

  return { tooltipTopPosition };
}
